import React = require('react');
import { Button, Modal } from 'react-bootstrap';
import { AdmiralCardWarning } from '../../../../Components/AdmiralCardWarning';

interface IDeclineModalProps {
  showDeclineModal: boolean;
  title: string;
  onCloseModal: () => any;
  closeButtonText: string;
  body: any;
}

export const DeclineModal = ({ showDeclineModal, title, onCloseModal, closeButtonText, body }: IDeclineModalProps) => {
  return (
    <Modal show={showDeclineModal} onHide={onCloseModal} backdrop={'static'}>
      <Modal.Body>
        <AdmiralCardWarning icon={'warning.svg'} title={title}>
          {body}
          {closeButtonText && (
            <Button
              onClick={onCloseModal}
              className={'admiral-primary-btn'}>
              {closeButtonText}
            </Button>
          )}
        </AdmiralCardWarning>
      </Modal.Body>
    </Modal>
  )
}
